import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBrazil = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 512 512",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 256,
			cy: 256,
			r: 256,
			fill: "#6da544"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ffda44",
			d: "M256 100.2 467.5 256 256 411.8 44.5 256z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 256,
			cy: 256,
			r: 89,
			fill: "#f0f0f0"
		}),
		/* @__PURE__ */ _jsx("g", {
			fill: "#0052b4",
			children: /* @__PURE__ */ _jsx("path", { d: "M211.5 250.4c-15.5 0-30.4 2.4-44.5 6.8A89 89 0 0 0 329 307a150 150 0 0 0-117.5-56.7zM343.4 273a89 89 0 0 0-169.2-52.2 183.7 183.7 0 0 1 169.2 52.3z" })
		})
	]
});
export default SvgBrazil;
